import AppState from 'app/state/AppState';
import _ from 'lodash';
const BookElement = {};

BookElement.isNotSelected = path => {
  return AppState.selectedSection[1] !== path[1];
};

BookElement.extractChapterNumber = path => {
  return path[1].replace(/chapter /i, '');
};

BookElement.extractTitleFromPath = path => {
  return _.chain(path)
    .last()
    .split(' ')
    .map(_.capitalize)
    .join(' ')
    .value();
};

export default BookElement;



// WEBPACK FOOTER //
// ./src/app/api/bookElement.js